var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"visual-viewport-height"},[(_vm.loading)?_c('q-inner-loading',{attrs:{"showing":""}},[_c('q-spinner-ios',{attrs:{"size":"lg"}})],1):_c('router-view',{attrs:{"attendee":_vm.attendee},on:{"exit":_vm.exit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }